import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
// Components
import Icon from "../../elements/icon";
import api from "../../utils/api";
import queryRoutes from "../../Graphql/queryRoutes";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
// Styles
import "./style.scss";

const Breadcrumbs = ({ rendering, fields, page, lang, dynmicBreadcrumbs, match }) => {
  // const { backToTopText } = fields;
  // const breadrumb = page.fields;

  // const [links, setLinks] = useState([]);
  // const [sitemapData, setSitemapData] = useState();

  // const getSiteMap = () => {
  //   const query = queryRoutes({
  //     lang: lang
  //   });
  //   api
  //     .graphql(null, { query })
  //     .then(res => {
  //       let homeNode = res.data.routes;
  //       let result = siteMaplevel(homeNode, [], null);

  //       setSitemapData(result);
  //     })
  //     .catch(error => {
  //       console.log("failed to get sitemap:", error);
  //     });
  // };

  // const siteMaplevel = (node, pages, parentPath) => {
  //   let page = breadcrumbDataNode(node, parentPath);
  //   pages.push(page);

  //   if (node?.children?.length === 0) {
  //     return pages;
  //   }

  //   node?.children &&
  //     node.children.forEach(childNode => {
  //       return siteMaplevel(childNode, page.childPages, page.url);
  //     });
  //   return pages;
  // };

  // const breadcrumbDataNode = (node, parentPath) => {
  //   return {
  //     breadcrumbName: node.fields.find(x => x.name === "text")?.value,
  //     url: parentPath ? `${parentPath}/${node.name}` : `/${lang}`,
  //     urlLevelText: parentPath ? node.name : lang,
  //     childPages: []
  //   };
  // };

  // const fomatBreadcrumbs = () => {
  //   let _links = [];

  //   let urlParts = window.location.pathname.split("/");
  //   urlParts = urlParts.slice(2, urlParts.length);

  //   if (!urlParts.length || (urlParts.length === 1 && urlParts[0] === "")) {
  //     // we are on home page do not show breadcrumbs
  //     return;
  //   } else if (urlParts[urlParts.length - 1] === "") {
  //     // remove last if trailing slash
  //     urlParts = urlParts.slice(0, urlParts.length - 1);
  //   }

  //   //get Home node
  //   _links.push({ name: sitemapData[0].breadcrumbName, path: `/${lang}` });

  //   let parentSitemapNode = sitemapData[0];
  //   // remove exqmple product and brand from breadcrumbs those are not pages on there own.
  //   const numberOfCustomNodes = dynmicBreadcrumbs?.length; //? dynmicBreadcrumbs?.length * 2 : 1;

  //   const { model, spu_id, brand_name } = match.params;

  //   let pages = [];

  //   /** Special routing
  //    *  remove pages that dont exist
  //    *  in sitecore
  //    */
  //   /** product page or brand page */
  //   if (spu_id || brand_name) {
  //     pages = urlParts.slice(0, urlParts.length - (numberOfCustomNodes + 1));
  //   } else if (model) {
  //     /** user manual model page */
  //     pages = urlParts.slice(0, urlParts.length - numberOfCustomNodes);
  //   } else if (urlParts.indexOf("t") >= 0) {
  //     /** Tab menu any content */
  //     const indexOfT = urlParts.indexOf("t");
  //     pages = urlParts.slice(0, indexOfT);
  //   } else if (urlParts.indexOf("l") >= 0) {
  //     /**  calculation tool */
  //     const indexOfL = urlParts.indexOf("l");
  //     pages = urlParts.slice(0, indexOfL);
  //   } else if (urlParts[0] === "stories") {
  //     pages = [];
  //   } else if (urlParts.findIndex(el => el.includes("pdp")) >= 0) {
  //     /** pdp page */
  //     const indexOfPpd = urlParts.findIndex(el => el.includes("pdp"));
  //     const tempPage = urlParts.slice(0, indexOfPpd + 1);
  //     const tempUrl = tempPage[0] + "/" + tempPage[1];
  //     pages.push(tempUrl);
  //   } else {
  //     pages = urlParts.slice(0, urlParts.length - 1);
  //   }

  //   pages.forEach(page => {
  //     //get parent
  //     let curretntNode = parentSitemapNode?.childPages?.find(x => x.urlLevelText.toLowerCase() === page.toLowerCase());
  //     if (curretntNode) {
  //       _links.push({ name: curretntNode?.breadcrumbName, path: curretntNode?.url, callback: curretntNode?.callback });
  //     } else {
  //       const tempUrl = page.split("/");

  //       _links.push({ name: tempUrl[1], path: tempUrl[1] });
  //     }

  //     parentSitemapNode = curretntNode;
  //   });

  //   //current page
  //   if (dynmicBreadcrumbs && dynmicBreadcrumbs.length) {
  //     dynmicBreadcrumbs.forEach(node => {
  //       _links.push({ name: node.breadcrumbName, path: node?.url || "#", callback: node?.callback });
  //     });
  //   } else {
  //     _links.push({ name: breadrumb.text.value, path: "#" });
  //   }

  //   setLinks(_links);
  // };

  // useEffect(() => {
  //   if (!sitemapData) {
  //     getSiteMap();
  //   } else {
  //     if (!breadrumb.doNotShowBreadcrums.value) {
  //       fomatBreadcrumbs();
  //     }
  //   }
  // }, []);

  // useEffect(() => {
  //   if (!breadrumb.doNotShowBreadcrums.value && sitemapData) {
  //     fomatBreadcrumbs();
  //   }
  // }, [sitemapData, page, dynmicBreadcrumbs]);

  // if (!page.fields.doNotShowBreadcrums.value) {
  //   return (
  //     <div className={"grid full-width breadcrumbs"} datasourceid={rendering.dataSource}>
  //       <div className="content">
  //         <div className="links">
  //           {links.map(({ path, name, callback }, index) => {
  //             if (path) {
  //               return (
  //                 <span key={name + "-" + index}>
  //                   <Link to={path} className="link" onClick={callback}>
  //                     {name}
  //                   </Link>
  //                   <Icon name="ArrowForward" />
  //                 </span>
  //               );
  //             }
  //           })}
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }

  return <></>;
};

const mapStateToProps = state => ({
  ...state
});
export default withRouter(connect(mapStateToProps, null)(Breadcrumbs));
